export const ADD_CONTENT_TO_LIST = "ADD_CONTENT_TO_LIST";
export const REMOVE_CONTENT_TO_LIST = "REMOVE_CONTENT_TO_LIST";
export const EMPTY_LIST_LEARNING_CONTENT = "EMPTY_LIST_LEARNING_CONTENT";
